import { Suspense } from 'react'
import React from 'react'
import { Outlet } from 'react-router-dom'

import { ActiveClinicProvider } from '@modules/active-clinic/core/ActiveClinicProvider'
import { CustomerDisplayProvider } from '@modules/customer-display/providers/CustomerDisplayProvider'
import { PermissionsProvider } from '@modules/permissions/core/PermissionsProvider'
import { QueryStringProvider } from '@modules/query-string/core/QueryStringProvider'
import { SplashScreen } from '@modules/splash-screen/components/SplashScreen'
import { NuqsAdapter } from 'nuqs/adapters/react-router'

const App = () => {
  return (
    <React.Fragment>
      <Suspense fallback={<SplashScreen />}>
        <QueryStringProvider>
          <NuqsAdapter>
            <ActiveClinicProvider>
              <PermissionsProvider>
                <CustomerDisplayProvider>
                  <Outlet />
                </CustomerDisplayProvider>
              </PermissionsProvider>
            </ActiveClinicProvider>
          </NuqsAdapter>
        </QueryStringProvider>
      </Suspense>
    </React.Fragment>
  )
}

export { App }
